const actions = {
    MASTER_ADD_NEW: 'MASTER_ADD_NEW',
    MASTER_READ: 'MASTER_READ',
    MASTER_READ_SUCCESS: 'MASTER_READ_SUCCESS',
    MASTER_UPDATE: 'MASTER_UPDATE',
    MASTER_FIND_BY_ID: 'MASTER_FIND_BY_ID',
    MASTER_LIST_SUCCESS: 'MASTER_LIST_SUCCESS',
    MASTER_ITEM_SUCCESS: 'MASTER_ITEM_SUCCESS',
    
    masterAddNew:(history, dataObj) => ({ //Action creator function
      type: actions.MASTER_ADD_NEW, //Action
      payload: { history, dataObj } //pass payload to action, we should pass as little data to action
    }),

    masterRead:(readFilter, page) => ({ //Action creator function
      type: actions.MASTER_READ, //Action
      payload: { readFilter, page } //pass payload to action, we should pass as little data to action
    }),
    onPageChange: (readFilter, page) => ({
      type: actions.MASTER_READ,
      payload: { readFilter, page }
    }),
    masterReadSearchSuccess: (data, success, total_count, page, info) => ({
      type: actions.MASTER_READ_SUCCESS,
      data,
      success,
      total_count,
      page,
      info
    }),

    masterFindById: (masterId) => ({
      type: actions.MASTER_FIND_BY_ID,
      payload: { masterId }
    }),

  

  };
  export default actions;